function AlarmHistory() {
    /// <summary>
    /// This object provides common functions for the Widget.Events.alarmHistory. <br/>
    /// Author: ARF<br />
    /// Date: 10.9.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 21.4.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added dropdown for multiple entry deleting                       *<br />.
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.12.2015                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
AlarmHistory.prototype = new vcTemplate();

AlarmHistory.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        if (me.fixedHeight) {

            me.visual.find(".vc-list").height(parseInt(me.height - me.visual.find("#divHeader").outerHeight()-7), 10);
            me.visual.find(".vc-list").css("overflow-y", "auto");
        }
      
     //init list entry click handler
      me.showDetailHandler();

    //inits the reload button
      me.visual.find('#divBtnReload').button().unbind('click').click(function() {
          return me.reload();
      });
   
        me.filter();

       //inits filter 
        me.visual.find('#txtFilter').keyup(function () {
            me.filter();
            // me.visual.find('#lstAlarm li').show();
            //me.visual.find("#lstAlarm li:not(:contains('" + me.visual.find('#txtFilter').val() + "'))").hide();
        });
        me.visual.find('#txtFilter').change(function () {
            me.visual.find('#lstAlarm li').show();
            me.visual.find("#lstAlarm li:not(:contains('" + me.visual.find('#txtFilter').val() + "'))").hide();
        });

        me.visual.find('.filter').off('click', '#divBtnFilterProjects').on('click', '#divBtnFilterProjects', function (e) {
            me.toggleProjectFilter($(this)); e.stopPropagation();
        });

        me.visual.find('.filter').off('click', '#divBtnFilterCurrent').on('click', '#divBtnFilterCurrent', function (e) {
            me.toggleCurrent($(this)); e.stopPropagation();
        });
     

        me.visual.find('#ddlDelete').off('change').on("change", function(e) {
            me.goForDelete($(this));
            e.stopPropagation();
        });

        //init the vcDate
        me.visual.find("#div-date-box").vcDate({ mode: "Range", defaultRange: { from: me.startDate, to: me.endDate }, align: "right", interval: 1, langID: me.userLangidForCulture });

       
        if (me.aid.length > 0) {
            me.toggleCurrent(me.visual.find('.filter #divBtnFilterCurrent'));
        }
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


AlarmHistory.prototype.toggleProjectFilter = function (obj) {
    /// <summary>
    /// This function adds/removes the filter for the current project. 
    /// </summary>
    var me = this;
    try {
        obj.toggleClass("ui-tabs-active ui-state-active filterOn");
       
        me.reload();
        return true;
    } catch (ex) { me.writeError('toggleProjectFilter', ex); return false; }
};


AlarmHistory.prototype.toggleCurrent = function (obj) {
    /// <summary>
    /// This function adds/removes the filter for the current alarms only. 
    /// </summary>
    var me = this;
    try {
        obj.toggleClass("ui-tabs-active ui-state-active filterOn");

        if (obj.hasClass("filterOn")) {
            me.visual.find("#divCalendar,#divBtnReload").fadeOut();
        } else {
            me.visual.find("#divCalendar,#divBtnReload").fadeIn();
        }

        me.reload();

        return true;
    } catch (ex) { me.writeError('toggleCurrent', ex); return false; }
};



AlarmHistory.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes the filter for the current alarms only. 
    /// </summary>
    var me = this;
    try {
       
        me.visual.find('#lstAlarm li').show();
        me.visual.find("#lstAlarm li:not(:contains('" + me.visual.find('#txtFilter').val() + "'))").hide();
       
        me.visual.find("#lstAlarm .alarm-chart-frame li").show();
       // console.info(me.visual.find("#lstAlarm .alarm-chart-frame li:contains('" + me.visual.find('#txtFilter').val() + "')"));
        if (me.showLongTermValidationOnly) {
            _VCMQ.produce(me.visual, me.vcgid, 'LONGTERMVALIDATION', { "alarms": me.visual.find('#lstAlarm li:visible').length });
        }
        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }
};

AlarmHistory.prototype.reload = function () {
    /// <summary>
    /// This function relaods the alarm history list based on the given settings. 
    /// </summary>
    var me = this;
    var bFilterProjects, bFilterCurrent;
    var dates;
    try {
        if (me.error) {
            return false;
        }
        bFilterProjects = me.visual.find('#divBtnFilterProjects').hasClass('filterOn');
        bFilterCurrent = me.visual.find('#divBtnFilterCurrent').hasClass('filterOn');

        dates = me.visual.find("#div-date-box").vcDate("getDate");
        me.visual.find('.vc-list').html(me.vcC.getLoadingIcon());

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({'AID':me.aid,  'StartDate': dates.from, 'EndDate': dates.to, 'AllProjects': bFilterProjects, 'ShowCurrentAlarms': bFilterCurrent, "showUnitOnly": me.showUnitOnly, "showLongTermValidationOnly": me.showLongTermValidationOnly, "UnitID": me.UnitID }), '', me.deviceType, me.langid, '1',
            function(result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData,true);
                    return false;
                }
                if (result === '') {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                me.visual.find('.vc-list').html(result);
                if (me.fixedHeight) {

                    me.visual.find(".vc-list").height(parseInt(me.height - me.visual.find("#divHeader").outerHeight() - 7), 10);
                    me.visual.find(".vc-list").css("overflow-y", "auto");
                }
                me.filter();

              
                me.showDetailHandler();
                
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};


AlarmHistory.prototype.showDetailHandler = function (e) {
    /// <summary>
    /// This function inits the click handler for one single alarm entry and loads the detail view. <br/>
    /// It adds the click handler for the quitting checkbox as well.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //we have no details for longterm validation
      

        //init list entry click handler
        me.visual.find('li .vc-list-item').not(".btnAlarmInfo").unbind('click').click(function () {
            var obj = {};


            obj.id = parseInt($(this).attr('data-id'), 10);
            obj.aid = parseInt($(this).attr('data-aid'), 10);
            obj.rid = parseInt($(this).data('rid'), 10);
            obj.bsdid = parseInt($(this).attr('data-bsdid'), 10);
            obj.blid = parseInt($(this).attr('data-blid'), 10);
            obj.date = $(this).attr('data-date');
            obj.alarmtype = parseInt($(this).data('alarmtype'), 10);

            if (me.showLongTermValidationOnly) {
               
                _VCMQ.produce(me.visual, -1, 'MANUAL_EDIT_DAY', { 'loggerid': obj.blid, 'day': obj.date });
               
                return false;
            } else {

                if (me.visual.find('#divDetail' + obj.id).hasClass('visible')) {
                    me.visual.find('#divDetail' + obj.id).removeClass('visible').hide().html('');
                    $(this).removeClass('visible');
                } else {
                    $(this).addClass('visible');
                    me.visual.find('#divDetail' + obj.id).addClass('visible').show();

                    me.fillDetail(obj);
                }
               
            }
        });



        me.visual.find('.btnAlarmInfo').off('click').on('click', function (e) {
            me.showAlarmInfo($(this).data("blid"), $(this).data("id"));
            e.stopPropagation();
        });

        //init quit checkbox click handler
        me.visual.find('.chkQuit').unbind('click').click(function (e) {
            var obj = $(this);
            var id = parseInt($(this).attr('data-id'), 10);

            var manualReset = $(this).attr('data-manualReset');

            window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 0, 'id': id, 'manualReset': manualReset }),
                function (result) {

                    if (result == null) { me.showMessage(me.resources.err_loadData, true); return false; }
                    if (result === false) {
                        me.showMessage(me.resources.err_loadData, true);
                    } else {
                        obj.hide();
                        // me.visual.find('#chkQuit' + id).hide();
                        me.visual.find('#iconQuit' + id).show();
                    }
                    return false;
                });
            e.stopPropagation();
        });

        me.visual.find('.chkDelete').unbind('click').click(function (e) { e.stopPropagation(); });


    

       
      return true;
    } catch (ex) { me.writeError('showDetailHandler', ex); return false; }
};



AlarmHistory.prototype.fillDetail = function (obj) {
    /// <summary>
    /// This function fills the detail placeholder for one single alarm entry.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        var objDetail = me.visual.find('#divDetail'+obj.id);
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        objDetail.html(me.vcC.getLoadingIcon());


        switch (obj.alarmtype) {
            case 1:
                if (me.mobile && me.width < 600) {
                    objDetail.height(50).html("<div class='note'>" + me.resources.notAvailableMobile + "</div>");
                } else {
                objDetail.height(me.heightDigitalTrend);
                me.vcVisual.addVisualByName('divDet', 'VISUAL_DIGITALTREND', 'ail' + obj.id, obj.date, parseInt(objDetail.height(), 10), parseInt(objDetail.width(), 10) - 20, obj.blid, JSON.stringify({ 'DigitalTrendType': 4, 'BSDID': obj.bsdid }), me.deviceType);
}
                break;
            case 2:
                objDetail.height(me.heightAlarmChart);
                me.vcVisual.addVisualByName('divDet', 'VISUAL_EVENTS_ALARMCHART', 'ail' + obj.id, obj.date, parseInt(objDetail.height(), 10), parseInt(objDetail.width(), 10) - 20, JSON.stringify({ 'alarmhistoryid': obj.id, 'isHistory': true }), '', me.deviceType);
                break;
            case 3:
                if (me.mobile) {
                    objDetail.height(50).html("<div class='note'>" + me.resources.notAvailableMobile + "</div>");
                    
                } else {
                    objDetail.height(me.heightAlarmChart+200);
                    me.vcVisual.addVisualBaseByName('divDet', 'VISUAL_ALARM_CHART_FRAME', 'ail' + obj.id, obj.date, parseInt(objDetail.height(), 10), parseInt(objDetail.width(), 10) - 20, JSON.stringify({ 'alarmid': obj.aid, "ShowHistory": true }), '', me.deviceType);
                }
                break;
            case 4:
                if (me.mobile) {
                    objDetail.height(50).html("<div class='note'>" + me.resources.notAvailableMobile + "</div>");

                } else {
                    objDetail.height(me.heightAlarmChart + 200);
                    me.vcVisual.addVisualBaseByName('divDet', 'VISUAL_ALARM_CHART_FRAME', 'ail' + obj.id, obj.date, parseInt(objDetail.height(), 10), parseInt(objDetail.width(), 10) - 20, JSON.stringify({ 'alarmid': obj.aid, "ShowHistory": true }), '', me.deviceType);
                }
                break;
            
        default:
        }


        //if (obj.rid>0) {
        //   } else {
        //    }
        return true;
    } catch (ex) { me.writeError('fillDetail', ex); return false; }
};



AlarmHistory.prototype.showAlarmInfo = function (blid, aid) {
    /// <summary>
    /// This function opens a system-wide popup and shows the signal analog summary. 
    /// The width and height is fixed - otherwise we get too many problems with the different menu points in the summary popup.
    /// </summary>
    var me = this;
    try {

        var random = parseInt(Math.random() * 100000, 10);
        var popup = $("<div>").attr("id", "popupDialog" + random);
        var visual = new vcVisual;

        popup.dialog({
            autoOpen: true,
            modal: true,
            width: 1030,
            height: 600,
            resizable: false,
            dialogClass: "saveDialog",
            title: "",
            closeOnEscape: true,
            position: { my: 'top+10%', at: 'top', of: window },

            buttons: [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    popup.dialog('close');
                    return true;
                }
            }]
        });

        visual.addVisualBaseByName('popupDialog', "WIDGET_EVENTS_ALARMINFO", random, getCurrentTimestamp(), 500, 1030, "", JSON.stringify({ "loggerid": blid, "alarmid": aid }), me.deviceType);
        return true;

    } catch (ex) { me.writeError('showAlarmInfo', ex); return false; }
};

AlarmHistory.prototype.goForDelete = function (obj) {
    /// <summary>
    /// opens a save/delete dialog. 
    /// </summary>
    var me = this;
    try {
        switch (parseInt(obj.val(),10)) {
            case 0:
                if (me.visual.find(".chkDelete:checked").length === 0) {alert(me.resources.noEntriesSelected);return false;}
                me.deleteDialog(1, me.resources.shouldMarkAsDeleted);
                break;
            case 1:
                if (me.visual.find(".chkDelete:checked").length === 0) { alert(me.resources.noEntriesSelected); return false; }
                me.deleteDialog(2, me.resources.shouldDeletePermanently);
                break;

            default: break;
        }
        
        return false;
    } catch (ex) { me.writeError('goforDelete', ex); return false; }
};

AlarmHistory.prototype.deleteDialog = function (type, message) {
    /// <summary>
    /// opens a save/delete dialog. 
    /// </summary>
    var me = this;
    try {
       

        var dialog = $('<p>' + message + '</p>').dialog({
            title: me.resources.saveDialogTitle, modal: true,
            buttons: {
                "Yes": function () {
                      me.delete(type); dialog.dialog('close'); },
                "No": function () {  dialog.dialog('close'); },
                "Cancel": function () { dialog.dialog('close'); return false; }
            },
            dialogClass: 'saveDialog'
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue
        return false;
    } catch (ex) { me.writeError('deleteDialog', ex); return false; }
};

AlarmHistory.prototype.delete = function (type) {
    /// <summary>
    /// This function deletes one history entry. 
    /// </summary>
    var me = this;
    var lstAlarmHistoryIDs = [];
    try {
        
        me.visual.find(".chkDelete:checked").each(function () { lstAlarmHistoryIDs.push(parseInt($(this).attr("data-id"), 10)); });
       
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': type, 'lstAlarmHistoryIDs': lstAlarmHistoryIDs }),
          function (result) {
              if (result == null) { me.showMessage(me.resources.err_saveData, true); return false; }
              if (result === false) {
                  me.showMessage(me.resources.err_saveData, true);
                  return false;
              } else {
                  me.reload();
              }
              return true;
          });
        return false;
    } catch (ex) { me.writeError('delete', ex); return false; }
};


AlarmHistory.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divHeader, #listHeader, .vc-list').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


AlarmHistory.prototype.doEvent = function () {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>

};

